var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.418 3.85156H17.418V2.35156H15.918V3.85156H9.91797V2.35156H8.41797V3.85156H5.41797C4.59297 3.85156 3.91797 4.52656 3.91797 5.35156V20.3516C3.91797 21.1766 4.59297 21.8516 5.41797 21.8516H20.418C21.243 21.8516 21.918 21.1766 21.918 20.3516V5.35156C21.918 4.52656 21.243 3.85156 20.418 3.85156ZM20.418 20.3516H5.41797V9.85156H20.418V20.3516ZM20.418 8.35156H5.41797V5.35156H8.41797V6.85156H9.91797V5.35156H15.918V6.85156H17.418V5.35156H20.418V8.35156Z",
    fill: "#0F1011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8583391c8ff1c8bdd426f6f2efef894d.svg";
export { ForwardRef as ReactComponent };